import { useForm } from "@inertiajs/react"
import { Modals, useModals } from "@/hooks/useModals"
import Button from "@/components/Button"
import Modal from "@/components/Modal"
import ErrorMessage from "@/components/ErrorMessage"

const AddEventModal = () => {
  const { activeModal, closeModal } = useModals()
  const isOpen = activeModal === Modals.AddEvent

  const { data, setData, post, processing, errors, reset } = useForm({
    name: "",
    location: "",
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post("/events", {
      async: true,
      preserveScroll: true,
      onSuccess: () => {
        reset()
        closeModal()
      },
    })
  }

  return (
    <Modal show={isOpen} onClose={closeModal} title="Add new event">
      <form onSubmit={handleSubmit} className="mt-4 space-y-4">
        <div>
          <label
            htmlFor="name"
            className="block text-sm leading-6 font-medium text-gray-900"
          >
            Name
          </label>
          <input
            type="text"
            id="name"
            required
            className="focus:ring-chessdrop-600 mt-1 block w-full rounded-lg border-0 py-2 text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
            value={data.name}
            onChange={(e) => setData("name", e.target.value)}
          />
          <ErrorMessage className="mt-1.5" message={errors.name} />
        </div>

        <div>
          <div className="flex justify-between gap-x-4">
            <label
              htmlFor="location"
              className="block flex-1 text-sm leading-6 font-medium text-gray-900"
            >
              Location
            </label>
            <span className="text-sm text-gray-600">Optional</span>
          </div>

          <input
            type="text"
            id="location"
            className="focus:ring-chessdrop-600 mt-1 block w-full rounded-lg border-0 py-2 text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
            value={data.location}
            onChange={(e) => setData("location", e.target.value)}
          />
        </div>

        <Button loading={processing} type="submit" fullWidth>
          Add event
        </Button>
      </form>
    </Modal>
  )
}

export default AddEventModal
